import { z } from 'zod';
import { IndicatorType } from '@shared/types';
import { MaInputSchema } from './ma.schema';
import { ZigZagInputSchema } from './zig-zag.schema';

export const RsiInputSchema = z.object({
  type: z.literal(IndicatorType.RSI),
  ma: MaInputSchema.optional(),
  period: z.number(),
  zigZag: ZigZagInputSchema.optional()
});

export type RsiInput = z.infer<typeof RsiInputSchema>;
